/**
 * Normalizes a given string by removing diacritical marks and converting it to lowercase.
 *
 * This function takes a string and performs the following operations:
 * - Normalizes the string using Unicode Normalization Form D (NFD).
 * - Removes diacritical marks (accents) using a regular expression.
 * - Converts the string to lowercase.
 *
 * @param {string} [str=""] - The string to be normalized. Defaults to an empty string if not provided.
 * @returns {string} The normalized string.
 * @example
 * const normalizedStr = normalizeString("Élève");
 * console.log(normalizedStr); // Output: "eleve"
 */

export const normalizeString = (str = "") => str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();